import { Avatar, Descriptions, Divider, Drawer, Image } from "antd";
import parse from "html-react-parser";

import moment from "moment";

function ViewDetail(props: any) {
  let { openViewDetail, setOpenViewDetail, dataViewDetail } = props;
  const onClose = () => {
    setOpenViewDetail(false);
  };
  return (
    <>
      <Drawer
        title="Chức năng xem chi tiết"
        width={"50vw"}
        onClose={onClose}
        open={openViewDetail}>
        <Descriptions title="Thông tin danh mục" bordered column={2}>
          <Descriptions.Item label="Public ID" span={2}>
            {dataViewDetail?.public_id}
          </Descriptions.Item>
          <Descriptions.Item label="Bytes" span={2}>
            {dataViewDetail?.bytes}
          </Descriptions.Item>
          <Descriptions.Item label="url" span={2}>
            {dataViewDetail?.url}
          </Descriptions.Item>
          <Descriptions.Item label="Asset folder" span={2}>
            {dataViewDetail?.asset_folder}
          </Descriptions.Item>
          <Descriptions.Item label="Format" span={2}>
            {dataViewDetail?.format}
          </Descriptions.Item>
          <Descriptions.Item label="Image" span={2}>
            {<Image src={dataViewDetail?.url} preview={false} />}
          </Descriptions.Item>
          <Descriptions.Item label="Ngày tạo">
            {moment(dataViewDetail?.createdAt).format("DD-MM-YY HH:mm:ss")}
          </Descriptions.Item>
          <Descriptions.Item label="Ngày cập nhật">
            {moment(dataViewDetail?.updatedAt).format("DD-MM-YY HH:mm:ss")}
          </Descriptions.Item>
        </Descriptions>
        {/* 
        <Divider orientation="left">Ảnh bài viết</Divider>
        <Avatar shape="square" size={200} src={dataViewDetail?.image} /> */}
      </Drawer>
    </>
  );
}

export default ViewDetail;
